import type { FC } from 'react';
import type { VolatilityRangeProps } from './types';
import VolatilityRangeContent from './volatility-range-content';
import { Widget } from '../../widget';
import { VolatilityRangeContext } from '../../../../providers/widgets/volatility-range-provider/volatility-range-provider';
import { useContext } from 'react';
import InlineOptions from '../../inline-options';
import { LookbackEnum } from '../../../../providers/widgets/volatility-range-provider/types';
import Source from '../../source';
import WidgetButtons from '../../widget-buttons';

const VolatilityRangeWidget: FC<VolatilityRangeProps> = (props) => {
  const { widget, actions } = props;

  const { selectedLookback, setSelectedLookback } = useContext(VolatilityRangeContext);

  const lookbackOptions = Object.values(LookbackEnum).map((value) => ({
    value,
    label: value,
  }));

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title="Volatility Range" />
        <Widget.HeaderPanel>
          <span style={{ marginRight: '8px', fontSize: '12px', color: '#d1dce6' }}>
            Lookback Window
          </span>
          <InlineOptions
            selectedOption={selectedLookback}
            onOptionChange={(option) => setSelectedLookback(option as LookbackEnum)}
            options={lookbackOptions}
          />
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <VolatilityRangeContent providerKey={props.providerKey} />
      <Widget.Footer>
        <Source source="Deribit" url="https://www.deribit.com/" />
      </Widget.Footer>
    </Widget>
  );
};

export default VolatilityRangeWidget;
